export const sans = '"Helvetica Neue", helvetica, arial, sans-serif';
export const proxima = `proxima-nova, ${sans}`;
